/*eslint-disable*/
import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import axios from 'axios'
import ability from '../plugins/ability'
import middlewarePipeline from './middlewares/middlewarePipeline'
import animate from 'vue2-animate/dist/vue2-animate.min.css';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueExcelXlsx from "vue-excel-xlsx";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import VueLazyload from 'vue-lazyload'
import VueParticlesBg from "particles-bg-vue";

Vue.component('v-select', vSelect)
Vue.use(Router);
Vue.use(animate);
Vue.use(axios)
Vue.use(VueSweetalert2);
Vue.use(VueExcelXlsx);
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: 'dist/error.png',
    loading: '/loaders/loader_turq.gif',
    attempt: 1
  });
  Vue.use(VueParticlesBg);

import routes from './routes'

/****** Routes  *********/
const router = new Router({
    mode:'history',
    routes,
    scrollBehavior: (to, from, savedPosition) => {
        if (savedPosition) {
            return savedPosition;
        } else if (to.hash) {
            return {
                selector: to.hash
            };
        } else {
            return { x: 0, y: 0 };
        }
    },
    linkActiveClass: "active",
    linkExactActiveClass: "exact-active",
});
const exceptionalRoutes = [
    'payment.gate',
    'settings',
    'categoriesclients',
    'developers.journal',
    'api',
    'invoice',
    'notifications',
    'developers.api.documentation',
    'transactions',
    'transferts_marchand',
    'transferts_client',
    'transferts_general',
    'users.histories',
    'users.details',
    'marchand.details',
    'users.services',
    'usersmeanspaiementconfirmation',
    'marchandmeansconfirmation',
    'newsletters',
    'newsletters_update',
    'list_newsletters',
    'transactionsetting',
    'newAccountMarchand',
    'exchangehistoriques',
    'intramwallets.details',
    'transactions.details',
    'reversements.configs',
    'adminreversements.configs',
    'reversements.get',
    'usermeanspaiments',
    'ConditionsUtilisateur',
    'customers',
    'products',
    'intramDirect',
    'customerdetails',
    'marchandtransactionsdetails',
    'intramBusiness',
    'intramScholar',
    'intramScholar.classes',
    'intramScholar.manage',
    'intramScholar.academic.years',
    'intramScholar.fees',
    'intramScholar.instalments',
    'intramScholar.settings',
    'intramScholar.transactions',
    'intramScholar.transaction.details',
    'intramScholar.class.fees',
    'intramScholar.class.students',
    'intramScholar.reduction.fees',
    'intramScholar.student.details',
    'intramScholar.payment.logs',
    'links_details',
    'intramAttributs',
    'intramSaveAttributs',
    'intramParameters',
    'marchandScheduleTransact',
    'intramServices',
    'services.administrator',
    'intramOptions',
    'intramServicesStats',
    'intramOptionsStats',
    'services.administrator',
    'intramOptions',
    'intramAds',
    'intramAdCategories',
    'intramAdCategoryAttributes',
    'intramAdDetails',
    'intramAnnuaires',
    'intramAnnuaireCategories',
    'intramAnnuaireCategoryAttributes',
    'intramAnnuaireDetails'
];
router.beforeEach((to, from, next) => {
        if (store.getters.auth && (!exceptionalRoutes.includes(to.name))){
            if (!ability.can('browse',to.name.capitalize())){
                return next({name:'dashboard'});
            }else{
                return next();
            }
        }
        if (!to.meta.middleware) {
            return next()
        }
        const middleware = to.meta.middleware;

        const context = {
            to,
            from,
            next,
            store
        };
        return middleware[0]({
            ...context,
            next: middlewarePipeline(context, middleware, 1)
        })
    
    });
    /*eslint-disabled*/
    router.beforeResolve((to, from, next) => {
        // If this isn't an initial page load.
        if (to.name) {
            // Start the route progress bar.
            NProgress.start()
        }
        next()
    })
    router.afterEach(() => {
        // Complete the animation of the route progress bar.
    
        NProgress.done()
    })
    

export default router
